// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"style_collapsible__1hjLf","map":"style_map__1gOxm","euLink":"style_euLink__2gN-D","root":"style_root__AdcVM"};